import { useAtom } from "jotai";
const { errorMessageAtomString } = require("../state");

const useErrorLogging = () => {
  const [, setErrorMessage] = useAtom(errorMessageAtomString);

  const logError = (error, info) => {
    setErrorMessage(error);
  };

  return {
    logError,
  };
};

export default useErrorLogging;
